import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class HomeService {
    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl;

    get() {
        return this.http.get<any>(this.baseurl + 'home');
    }
} 